// ============================================================
// FILE: resources/js/components/otpInput.js
// USPATIH GO — Alpine Component: OTP Input (6 kotak)
// ============================================================

import Alpine from 'alpinejs';

Alpine.data('otpInput', () => ({
  digits:   Array(6).fill(''),

  get value()      { return this.digits.join(''); },
  get isComplete() { return this.value.length === 6; },

  /**
   * Handle input di tiap kotak; auto-focus ke kotak berikutnya
   */
  handleInput(index, event) {
    const val = event.target.value.replace(/\D/, '');
    this.digits[index] = val ? val.slice(-1) : '';

    if (val && index < 5) {
      this.$nextTick(() => document.querySelector(`[data-otp="${index + 1}"]`)?.focus());
    }
  },

  /**
   * Handle Backspace & Arrow navigation antar kotak
   */
  handleKeydown(index, event) {
    if (event.key === 'Backspace' && !this.digits[index] && index > 0) {
      this.$nextTick(() => document.querySelector(`[data-otp="${index - 1}"]`)?.focus());
    }
    if (event.key === 'ArrowLeft'  && index > 0) document.querySelector(`[data-otp="${index - 1}"]`)?.focus();
    if (event.key === 'ArrowRight' && index < 5) document.querySelector(`[data-otp="${index + 1}"]`)?.focus();
  },

  /**
   * Handle paste — isi semua kotak sekaligus
   */
  handlePaste(event) {
    const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    pasted.split('').forEach((c, i) => { this.digits[i] = c; });
    event.preventDefault();
    document.querySelector(`[data-otp="${Math.min(pasted.length, 5)}"]`)?.focus();
  },
}));
